// Shared BAKER/BAKERY level thresholds — single authoritative import.
// Both frontend and backend import from @cookies/shared (or /levels).

export const BAKER_LEVEL_THRESHOLDS: bigint[] = [
  0n, 80n, 300n, 750n, 1600n, 3000n, 5000n, 8000n, 12000n, 18000n, 26000n, 36000n, 50000n,
];

export function bakerThresholdForLevel(level: number): bigint {
  if (level <= 0) return 0n;
  if (level <= BAKER_LEVEL_THRESHOLDS.length) return BAKER_LEVEL_THRESHOLDS[level - 1] ?? 0n;
  let total = BAKER_LEVEL_THRESHOLDS[BAKER_LEVEL_THRESHOLDS.length - 1] ?? 50000n;
  let step = 18000n;
  for (let lv = BAKER_LEVEL_THRESHOLDS.length + 1; lv <= level; lv++) {
    step = (step * 135n) / 100n;
    total += step;
  }
  return total;
}

export function bakerLevelForXp(xp: bigint): number {
  if (xp < 0n) return 1;
  let lv = 1;
  while (true) {
    const nxt = bakerThresholdForLevel(lv + 1);
    if (xp >= nxt) lv += 1;
    else break;
  }
  return lv;
}

export function bakerNextXp(level: number): bigint {
  if (level < 1) return BAKER_LEVEL_THRESHOLDS[0] ?? 0n;
  return bakerThresholdForLevel(level + 1);
}

export const BAKERY_LEVEL_THRESHOLDS: bigint[] = [
  0n, 15_000n, 150_000n, 750_000n, 3_000_000n, 15_000_000n, 60_000_000n, 250_000_000n, 1_000_000_000n, 4_000_000_000n, 20_000_000_000n,
];

export const MAX_BAKERY_LEVEL = BAKERY_LEVEL_THRESHOLDS.length;

export function bakeryThresholdForLevel(level: number): bigint {
  if (level <= BAKERY_LEVEL_THRESHOLDS.length) return BAKERY_LEVEL_THRESHOLDS[level - 1] ?? 0n;
  let total = BAKERY_LEVEL_THRESHOLDS[BAKERY_LEVEL_THRESHOLDS.length - 1] ?? 20_000_000_000n;
  const prev = BAKERY_LEVEL_THRESHOLDS[BAKERY_LEVEL_THRESHOLDS.length - 2] ?? 4_000_000_000n;
  let step = total > prev ? total - prev : 16_000_000_000n;
  for (let lv = BAKERY_LEVEL_THRESHOLDS.length + 1; lv <= level; lv++) {
    step = (step * 160n) / 100n;
    total += step;
  }
  return total;
}

export function bakeryLevelProgress(lifetime: bigint): { next: bigint; progress: number; level: number; isMax: boolean } {
  const safe = lifetime < 0n ? 0n : lifetime;
  let lv = 1;
  while (lv < 10000 && safe >= bakeryThresholdForLevel(lv + 1)) lv += 1;
  const cur = bakeryThresholdForLevel(lv);
  const nxt = bakeryThresholdForLevel(lv + 1);
  if (nxt <= cur) return { next: cur, progress: 100, level: lv, isMax: false };
  const denom = nxt - cur;
  if (denom <= 0n) return { next: cur, progress: 100, level: lv, isMax: false };
  const prog = Number(((safe - cur) * 100n) / denom);
  return { next: nxt, progress: Math.max(0, Math.min(100, Number.isFinite(prog) ? prog : 0)), level: lv, isMax: false };
}
